import { ProductCard } from './ProductCard';

export function FeaturedProducts({ products }) {
  if (!products.length) return null;

  return (
    <section className="border-y border-white/10 bg-bg2 px-4 py-16 sm:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="mb-2 text-xs font-extrabold uppercase tracking-[0.2em] text-accent">
              This week
            </div>
            <h2 className="text-2xl font-black tracking-tight sm:text-3xl">Weekly featured</h2>
          </div>
          <p className="max-w-xs text-sm text-text-muted">
            Hand-picked deals on the gadgets moving fastest this week — refreshed every Monday.
          </p>
        </div>

        <div className="-mx-4 flex snap-x gap-5 overflow-x-auto px-4 pb-2 sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 lg:grid-cols-4">
          {products.map((product) => (
            <div key={product.id} className="w-64 shrink-0 snap-start sm:w-auto">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
